import {createApp} from 'vue'

import {createPinia} from 'pinia'

import {Quasar, Loading, Notify} from 'quasar'

import {router} from './router'

// Import i18n
import {createI18n} from 'vue-i18n'
import {ruRU} from 'f2b-components'

const i18nInstance = createI18n({
    legacy: false,
    locale: 'ru-RU',
    fallbackLocale: 'ru-RU',
    messages: {
        'ru-RU': ruRU,
    },
})

// Import Quasar css
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import './css/app.scss'

import App from './App.vue'

const pinia = createPinia()

export const app = createApp(App)
    .use(i18nInstance)
    .use(router)
    .use(Quasar, {
        plugins: {
            Loading,
            Notify,
        },
        config: {
            brand: {
                primary: '#008080',
                secondary: '#ebedf0',
                accent: '#9C27B0',
                positive: '#21BA45',
                negative: '#ff3c2e',
                info: '#31CCEC',
                warning: '#F2C037',
                gray: '#9299a3',
            },
        },
    })
    .use(pinia)

